import { connect } from 'react-redux'
import { setModal } from 'actions/account'

const mapStateToProps = ({ modal }) => ({ modal })

const withRedux = connect(
  mapStateToProps,
  { setModal }
)

export default withRedux
